import Modal from "bootstrap/js/src/modal";

const formContainers = document.querySelectorAll('.wp-pakietymedyczne-form');

if (formContainers.length) {
    formContainers.forEach(formContainer => {
        const form = document.querySelector('form[ajaxForm]');
        const submitButton = formContainer.querySelector('button[type="submit"]');
        const modalID = formContainer.dataset.modalId;
        const modalDOM = document.querySelector(`#${modalID}`);
        const modal = new Modal(modalDOM);

        const modalErrorDOM = document.querySelector(`#${modalID}-error`);
        const modalError = new Modal(modalErrorDOM);

        form.addEventListener('submit', e => {
            e.preventDefault();
            e.stopPropagation();

            const formInputsData = new Map();
            const formData = new FormData(form);

            for (let [name, value] of formData) {
                if (value !== '') {
                    formInputsData.set(name, value);
                }
            }

            const allInputsDataObject = Object.fromEntries(formInputsData)

            if (form.checkValidity()) {
                disableForm();

                fetch(pakietymedyczneJSON.root + 'pakietymedyczne/v1/form/', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        'X-WP-Nonce': pakietymedyczneJSON.nonce
                    }),
                    body: JSON.stringify({ data: allInputsDataObject })
                }).then(response => {
                    return response.json()
                }).then(response => {
                    if (response.success) {
                        if (formInputsData.get('form_action') === 'imagene_test_form') {
                            const dataLayerObject = {
                                'event': 'imageneProductForm',
                                'formName': formInputsData.get('form_name'),
                                'productName': formInputsData.get('nazwa')
                            }
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(dataLayerObject);
                        }
                        unDisableForm();
                        modal.show();
                    } else {
                        unDisableForm();
                        modalError.show();
                    }
                }).catch((error) => console.log(error));
            }
        });

        const disableForm = () => {
            form.classList.add('disable');
            submitButton.classList.add('disable');
            form.reset();
        }

        const unDisableForm = () => {
            form.classList.remove('disable');
            submitButton.classList.remove('disable');
        }
    })
}

const formsInModal = document.querySelectorAll('[ajaxFormModal]');
if (formsInModal.length) {
    formsInModal.forEach(form => {
        const modalId = form.dataset.modalId;
        const modalElement = document.querySelector(`#${modalId}`);
        const modal = new Modal(modalElement);

        form.addEventListener('submit', (e) => {
            modal.hide();
        })
    })
}


const leaveContactForm = document.querySelectorAll('.wp-leave-contact');
if (leaveContactForm.length) {
    leaveContactForm.forEach(formContainer => {
        const contactMethodsRadio = formContainer.querySelectorAll('input[name="leaveContactRadio"]');
        const contactMethodsFieldset = formContainer.querySelectorAll('.wp-leave-contact__fieldset');
        const leaveContactThxModals = document.querySelectorAll('.leave-contact-modal-thx');

        contactMethodsRadio.forEach(radio => {
            radio.addEventListener('change', () => {
                contactMethodsFieldset.forEach(fieldset => {
                    fieldset.style.display = 'none';

                    const allInputs = fieldset.querySelectorAll('[data-fieldset-required]');
                    allInputs.forEach(input => {
                        input.required = false;
                    })
                })

                const targetFieldsetId = radio.dataset.section;
                const targetFieldset = formContainer.querySelector(`#${targetFieldsetId}`);
                targetFieldset.style.display = 'block';

                const allInputs = targetFieldset.querySelectorAll('[data-fieldset-required]');
                allInputs.forEach(input => {
                    input.required = true;
                })

                const contactMethodValue = formContainer.querySelector('input[name="leaveContactRadio"]:checked').value;

                if (leaveContactThxModals.length) {
                    leaveContactThxModals.forEach(modal => {
                        modal.dataset.contactMethod = contactMethodValue;
                    })
                }
            })
        })
    })
}

const leaveContactThxModals = document.querySelectorAll('.leave-contact-modal-thx');
if (leaveContactThxModals.length) {
    leaveContactThxModals.forEach(modal => {
        modal.addEventListener('show.bs.modal', event => {
            const leaveContactMethod = event.target.dataset.contactMethod;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'typeLeaveContact': leaveContactMethod,
                'event': 'LeaveContactTHX'
            });
        })
    })
}

const leaveContactModals = document.querySelectorAll('[data-leave-contact-modal]');
if (leaveContactModals.length) {
    leaveContactModals.forEach(modal => {
        modal.addEventListener('show.bs.modal', event => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'OpenLeaveContact' });
        })
    })
}